import styled from "styled-components";
import { colors } from "../../../theme/colors";

export const SectionTitle = styled.h3`
  font-size: 1.6rem;
  color: ${colors.text.withOpacity(0.5).hex};
  font-weight: 500;
  text-transform: uppercase;
`;
